import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrameOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M4 7h3m4 0h9" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 17h13" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 7v13" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 4v9m0 4v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 3l18 18" })
	]
});
const ForwardRef = forwardRef(SvgFrameOff);
export default ForwardRef;
